"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _customComponents = require("../../utils/customComponents");

var _customProps = require("../../utils/customProps");

var _MuiCardActions = _interopRequireDefault(require("./components/MuiCardActions/MuiCardActions"));

var _MuiCardContent = _interopRequireDefault(require("./components/MuiCardContent/MuiCardContent"));

var _MuiCardHeader = _interopRequireDefault(require("./components/MuiCardHeader/MuiCardHeader"));

var _MuiCardMedia = _interopRequireDefault(require("./components/MuiCardMedia/MuiCardMedia"));

var _MuiVideo = _interopRequireDefault(require("../MuiVideo/MuiVideo"));

var MuiCard = function MuiCard(_ref) {
  var rootClass = _ref.rootClass,
      raised = _ref.raised,
      content = _ref.content,
      elevation = _ref.elevation,
      square = _ref.square,
      variant = _ref.variant,
      height = _ref.height,
      width = _ref.width;
  var components = {
    MuiCardActions: _MuiCardActions.default,
    MuiCardContent: _MuiCardContent.default,
    MuiCardHeader: _MuiCardHeader.default,
    MuiCardMedia: _MuiCardMedia.default,
    MuiVideo: _MuiVideo.default
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    height: height,
    width: width
  });

  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: styles.root,
    raised: raised,
    variant: variant,
    elevation: +elevation,
    square: square
  }, content.map(function (component, key) {
    return (0, _customComponents.renderComponents)(components, component, key);
  }));
};

var _default = MuiCard;
exports.default = _default;
MuiCard.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: true | false
   * If true, the card will use raised styling.
   */
  raised: _propTypes.default.bool,

  /**
   * It accepts values between 0 and 24 inclusive.
   * Shadow depth, corresponds to dp in the spec.
   */
  elevation: _propTypes.default.string,

  /**
   * mui prop: true | false
   * If true, rounded corners are disabled.
   */
  square: _propTypes.default.bool,

  /**
   * mui prop: 'elevation' | 'outlined'
   * The variant to use.
   */
  variant: _propTypes.default.string,

  /**
   * Height of the card.
   */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * Width of the card.
   */
  width: function width(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * Content passed to render
   * can also render any customCompnent passed in
   * components:  MuiCardActions,
    MuiCardContent,
    MuiCardHeader,
    MuiCardMedia,
   */
  content: function content(props, propName, componentName) {
    var components = ['MuiCardActions', 'MuiCardContent', 'MuiCardHeader', 'MuiCardMedia'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  }
};
MuiCard.defaultProps = {
  raised: false,
  rootClass: [],
  height: '100%',
  width: '100%',
  content: [],
  elevation: 1,
  square: false,
  variant: 'elevation'
};